import { render, staticRenderFns } from "./ReferenceLetterPoint.vue?vue&type=template&id=be90464a&scoped=true"
import script from "./ReferenceLetterPoint.vue?vue&type=script&lang=js"
export * from "./ReferenceLetterPoint.vue?vue&type=script&lang=js"
import style0 from "./ReferenceLetterPoint.vue?vue&type=style&index=0&id=be90464a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be90464a",
  null
  
)

export default component.exports